import axios from '../axios'

const postLessonMaterialApi = async (lessonId, payload) => {
  return await axios.post(`api/lms/lessons/${lessonId}/materials`, payload)
}

export default postLessonMaterialApi
